/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { OutputReport2 } from './output-report-2';

export class FirmwareDataMessage extends OutputReport2 {
    constructor() {
        super();
        this.type = OutputReport2.MessageType.FIRMWARE_DATA;
    }

    set sequence(seq: number) {
        this.setUint16(2, seq, true);
    }

    get sequence() {
        return this.getUint16(2, true);
    }

    set data(data: Uint8Array) {
        this.totalBytes = data.length + 2;
        let offset = 4;
        data.forEach((byte) => this.setUint8(offset++, byte));
    }

    withSequence(seq: number) {
        this.sequence = seq;
        return this;
    }

    withData(bytes: Uint8Array) {
        this.data = bytes;
        return this;
    }

    override logMessage(): string {
        return `FirmwareDataMessage: seq:${this.sequence}, bytes: ${this.totalBytes}`
    }
}
